export * from './ProductDetailsReady';
